import { render, staticRenderFns } from "./OrderBinHead.vue?vue&type=template&id=f31361f4&scoped=true"
import script from "./OrderBinHead.vue?vue&type=script&lang=js"
export * from "./OrderBinHead.vue?vue&type=script&lang=js"
import style0 from "./OrderBinHead.vue?vue&type=style&index=0&id=f31361f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31361f4",
  null
  
)

export default component.exports